<a class="tender-card" [routerLink]="'/tenders/' + data()._id">
  <div class="tender-card__header">
    <span class="tender-card__badge">{{
      'home.tendersSection.bsaCompliantPost' | translate
    }}</span>

    @if (estimatedBudget()) {
      <div class="tender-card__budget">
        <span class="tender-card__budget-label">{{
          'home.tendersSection.estimatedBudget' | translate
        }}</span>
        <span class="tender-card__budget-value">{{ estimatedBudget() }}</span>
      </div>
    }
  </div>

  <h3 class="tender-card__title">
    <pwj-text-summarizer [limitLength]="56" [text]="data().title | translateData">
    </pwj-text-summarizer>
  </h3>

  <div class="tender-card__divider" aria-hidden="true"></div>

  <div class="tender-card__requirement-box">
    <p class="tender-card__requirement">
      <i class="tender-card__requirement-icon iconsax" icon-name="shield-tick"></i>
      {{ requirementText() | translate }}
    </p>
  </div>

  <div class="tender-card__actions">
    <span class="tender-card__cta">{{ 'home.tendersSection.applyToBid' | translate }}</span>
  </div>
</a>
